import classnames from 'classnames';
import { oneOf } from 'prop-types';
import React from 'react';

import { contactStatuses, STATUS_COLOR_MAP } from '../constants';

export default function ContactStatus({ status }) {
  const color = STATUS_COLOR_MAP[status];
  const colorClass = `border-${color} text-${color}`;

  return (
    <h6
      className={classnames(
        'm-0 border-2 rounded-pill',
        colorClass,
        'px-2 py-1',
      )}
    >
      {status}
    </h6>
  );
}

ContactStatus.propTypes = {
  status: oneOf(contactStatuses.map(s => s.value)).isRequired,
};
